import _ from 'lodash';
import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

const SERIALIZED_PROPS = ['loaded', 'showingMobileMenu'];

class MenuStore extends BaseStore {
  static storeName = 'MenuStore';

  static handlers = {
    TOGGLE_MOBILE_MENU() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'showingMobileMenu' does not exist on typ... Remove this comment to see the full error message
      this.showingMobileMenu = !this.showingMobileMenu;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ TO... Remove this comment to see the full error message
      this.emitChange();
    },
  };

  constructor(dispatcher: $TSFixMe) {
    super(dispatcher);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'showingMobileMenu' does not exist on typ... Remove this comment to see the full error message
    this.showingMobileMenu = false;
  }

  dehydrate() {
    return _.pick(this, ...SERIALIZED_PROPS);
  }

  rehydrate(state: $TSFixMe) {
    Object.assign(this, _.pick(state, ...SERIALIZED_PROPS));
  }

  hasLoaded() {
    return true;
  }

  getShowingMobileMenu() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'showingMobileMenu' does not exist on typ... Remove this comment to see the full error message
    return this.showingMobileMenu;
  }
}

export default MenuStore;
